/* eslint-disable import/prefer-default-export */
export const dateFormatShort = (date: Date, locales: string | string[] = 'nl-NL'): string => {
	const dateFormatterShort = new Intl.DateTimeFormat(locales, { dateStyle: 'short' });
	return dateFormatterShort.format(date);
};
